import { render } from "./BoatsPage.vue?vue&type=template&id=04cd3783"
import script from "./BoatsPage.vue?vue&type=script&lang=js"
export * from "./BoatsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__